import MDBoxRoot from './../MDBox/MDBoxRoot'
// wthT. marginLeft:wthT+"px",
function DashboardLayout( {owntheme, wthT, children }) {
    return (
      <MDBoxRoot  sx={{ 
        width: `calc(98% - ${wthT}px)`,  
        }}
      textAlign="center"
      theme={owntheme}
      >
        {children}
      </MDBoxRoot>
    );
  }

  
  export default DashboardLayout;
  